import { render, staticRenderFns } from "./writeoffForUserAdd.vue?vue&type=template&id=bbd418ba&scoped=true&"
import script from "./writeoffForUserAdd.vue?vue&type=script&lang=js&"
export * from "./writeoffForUserAdd.vue?vue&type=script&lang=js&"
import style0 from "./writeoffForUserAdd.vue?vue&type=style&index=0&id=bbd418ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd418ba",
  null
  
)

export default component.exports